export default {"src":"/_next/static/media/base.98dd6368.svg","height":184,"width":185,"blurWidth":0,"blurHeight":0};